import { createReducer, on } from '@ngrx/store';
import { FiltersState } from '../../models/filter.model';
import * as filterActions from '../actions/filter.action';


export const initialState: FiltersState = {

  isLoading: false,
  error: null,
  filters : {

    service_id: null,
    rider_id: null,
    status_id: null,
    cash_status: null,
    date: null,
    from: null,
    to: null,
    page: 1,
    limit: 5,

  },

};

export const filterReducer = createReducer(
  initialState,
  on(filterActions.updateFilters, (state, { filters }) => ({
     ...state,
    filters: {
      ...state.filters,
      ...filters, 
    },
  })),
  on(filterActions.cleanFilters, (state) => ({
    ...initialState,
  })),
  on(filterActions.cleanOneFilter, (state, { filter }) => ({
    ...state,
    [filter]: null, 
  }))
);
